import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/46.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Przyjmujesz ofertę"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p88,
            }}
            content={
                <div>
                    <ul>
                        <li>
                            Świetnie – Tornau wyciera rękę w szerokie spodnie i wyciąga do ciebie. – Witamy na pokładzie! Oskubiemy wszystkich!</li>
                        <li>
                            Kogo?
                        </li>
                        <li>
                            Gęsi, wszystkie gęsi! Do poduszek, do kołder… jesienią się skubie gęsie pierze, jak co roku!
                        </li>
                    </ul>
                    <p>
                    Po kilku kolejkach wychodzisz, zaczerpnąć świeżego powietrza. Patrzysz na Zagórów: miasteczko olędrów, Polaków i Żydów; gęsiarzy, rzemieślników i rybaków; oczek wodnych, łąk nadwarciańskich i wilgotnych lasów. A przede wszystkim twoich przyjaciół. I mówisz do siebie po cichu: „To mój nowy dom”.
                    </p>
                </div>
            }
        />

    );
}